import axios from 'axios';
import { settings } from '@/api/config';

import { getInitData } from '@/utils/getInitData';

const tg = window?.Telegram?.WebApp;
interface BannerCpmTask {
  id: number;
  type: string;
  view_details: {
    title: string;
  };
  details: Record<string, any>;
  rewards: {
    stars: number;
  };
  status: string;
  target_progress: number;
  user_progress: number;
}

interface UpdateProgressResponse {
  message: string;
  data: {
    task: BannerCpmTask;
  };
}

interface ClaimResponse {
  status: string;
  message: string;
  data?: {
    task: BannerCpmTask;
  };
}

export const getBannerCpmTasks = async () => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const response = await axios.get(
    `${settings.url}api/tasks/banners-cpm/get?initData=${encodedInitData}`,
  );
  console.log('🚀 Banner CPM tasks:', response);
  return response.data;
};

export const updateBannerCpmProgress = async (): Promise<BannerCpmTask> => {
  try {
    if (!getInitData()) {
      throw new Error('initData отсутствует');
    }
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.post<UpdateProgressResponse>(
      `${settings.url}api/banners/cpm/view?initData=${encodedInitData}`,
    );
    console.log('🎯 Banner CPM progress updated:', response.data);
    return response.data.data.task;
  } catch (error) {
    console.error('❌ updateBannerCpmProgress - error:', error);
    throw error;
  }
};

export const claimBannerCpmReward = async (
  taskId: number,
): Promise<ClaimResponse> => {
  try {
    console.log(
      '🚀 Отправляем запрос на получение награды для задания:',
      taskId,
    );
    if (!getInitData()) {
      throw new Error('initData отсутствует');
    }
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.post<ClaimResponse>(
      `${settings.url}api/tasks/claim/${taskId}?initData=${encodedInitData}`,
    );
    console.log('🎁 Banner CPM reward claimed:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ claimBannerCpmReward - error:', error);
    throw error;
  }
};

export const SendCPMInfo = async (provider: string): Promise<ClaimResponse> => {
  try {
    if (!getInitData()) {
      throw new Error('initData отсутствует');
    }
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.post<ClaimResponse>(
      `${settings.url}api/banners/${provider}/view?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('❌ claimBannerCpmReward - error:', error);
    throw error;
  }
};
export const claimCpmReward = async (): Promise<ClaimResponse> => {
  try {
    if (!getInitData()) {
      throw new Error('initData отсутствует');
    }
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.post<ClaimResponse>(
      `${settings.url}api/tasks/claim/2?initData=${encodedInitData}`,
    );
    console.log('🎁 Banner CPM reward claimed:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ claimBannerCpmReward - error:', error);
    throw error;
  }
};
